/**
 * Returns the store key
 * @param {Object} params - Store key params
 * @param {String} params.clientId - Auth0 clientId
 * @param {String} params.audience - Auth0 audience
 * @returns {String} - Store key
 */
const getStoreKey = (params) =>
    `ln-auth-tokens:${params.clientId}:${params.audience}`;

export { getStoreKey };
